import React from 'react';

const Card = (props) => {
    return (
        <div className={props.additionalClass+" card statistic-card"}>
            {props.children}
        </div>
    );
};

export default Card;